var contactSubmit = function (event) {
	var $contactForm = $('[name="contactForm"]');
	$contactForm
		.attr('action', 'complete-q.php')
		.submit();
}

module.exports = contactSubmit;